import useSWRImmutable from 'swr/immutable';
import {useLocation, useSearchParams} from 'react-router-dom';
import {useEffect, useState} from 'react';

const tags = ["женскоедвижениеединойроссии"].map((str) => `%22%23${encodeURI(str)}%22%2C`).join("").replace(/%2C\s*$/, "")
export const newsUrl = (region, page, count) => `${process.env.REACT_APP_NEWS_API}/news_list?per_page=${count}&tags=${tags}&regions=${!!region ? `[${region}]` : null}&page=${page}`

const fetcher = async (url) => {
    return await fetch(url).then(res => res.json())
}

export const useNews = (regionId, pageCount) => {
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const [newsData, setNewsData] = useState(null)
    const [meta, setMeta] = useState(null)
    const { data, isLoading } = useSWRImmutable(
        newsUrl(
            regionId,
            location.pathname.includes('/news') ? searchParams.get('page')  : 1,
            pageCount
        ), fetcher)

    useEffect(()=> {
        if (data) {
            setMeta(data?.meta)
            setNewsData(data?.data)
        }
    }, [data, setNewsData, setMeta])

    return {
        data: newsData,
        isLoading,
        meta,
    }
}
